import { LinearProgress, Box } from '@mui/material'
import { useIsFetching, useIsMutating } from '@tanstack/react-query'

export function GlobalProgressBar() {
  const fetching = useIsFetching()
  const mutating = useIsMutating()
  const active = fetching + mutating > 0
  return (
    <Box sx={{
      position: 'sticky', top: 0, zIndex: (t) => t.zIndex.appBar + 1,
      height: 2, pointerEvents: 'none',
    }}>
      {active && (
        <LinearProgress sx={{
          height: 2,
          backgroundColor: 'transparent',
          '& .MuiLinearProgress-bar': { transitionDuration: '0.5s' },
        }} />
      )}
    </Box>
  )
}
